import { CmsApiEmailCampaignSignupDoubleBlockData } from 'modules/cms/api/types/CmsApiEmailCampaignSignupDouble';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpEmailCampaignSignupDoubleBlock } from './CmsAmpEmailCampaignSignupDoubleBlock';
import { CmsEmailCampaignSignupDoubleBlock } from './CmsEmailCampaignSignupDoubleBlock';

export const CmsEmailCampaignSignupDoubleBlockMapping: CmsBlockMapping<CmsApiEmailCampaignSignupDoubleBlockData> =
  {
    invariant: [
      {
        prop: 'headline',
        msg: 'Heading required for Email Campaign Signup Double',
      },
      {
        prop: 'toggleTextOne',
        msg: 'Toggle Text One required for Email Campaign Signup Double',
      },
      {
        prop: 'buttonTextOne',
        msg: 'Button Text One required for Email Campaign Signup Double',
      },
      {
        prop: 'campaignIdOne',
        msg: 'Campaign ID One required for Email Campaign Signup Double',
      },
      {
        prop: 'listIdOne',
        msg: 'List ID One required for Email Campaign Signup Double',
      },
      {
        prop: 'toggleTextTwo',
        msg: 'Toggle Text Two required for Email Campaign Signup Double',
      },
      {
        prop: 'buttonTextTwo',
        msg: 'Button Text Two required for Email Campaign Signup Double',
      },
      {
        prop: 'campaignIdTwo',
        msg: 'Campaign ID Two required for Email Campaign Signup Double',
      },
      {
        prop: 'listIdTwo',
        msg: 'List ID Two required for Email Campaign Signup Double',
      },
    ],
    width: CmsBlockWidth.GRID,
    Component: CmsEmailCampaignSignupDoubleBlock,
    AmpComponent: CmsAmpEmailCampaignSignupDoubleBlock,
  };
